"use client";

import Link from "next/link";

import BookAppointmentButton from "../utilities/BookAppointmentButton";
import HomeSliderPhoto from "../utilities/HomeSliderPhoto";

export default function Welcome() {
  return (
    <section className="mx-auto w-full max-w-6xl py-10">
      <div className="mx-auto flex flex-col items-center justify-center lg:flex-row ">
        <div className="size-full rounded-md">
          <HomeSliderPhoto />
        </div>
        <div className="flex size-full rounded-md">
          <div className="mx-auto max-w-7xl p-4 text-center sm:px-6 lg:px-8">
            <h2
              className="text-3xl font-extrabold leading-none text-purple-500 sm:text-center lg:text-center xl:text-3xl"
              data-primary="purple-500"
            >
              Welcome to <br />
              Trichos Hospitals
            </h2>
            <p className="sm:text-small md:text-small z-0 mx-auto mt-2 max-w-md text-base text-gray-500 md:mt-3 md:max-w-3xl">
              Trichos Hair Transplant Institute & Research Center has emerged as
              the most sought-after clinic for best hair Transplant in South
              India. Where quality hair transplant meets affordability and
              ethics stands tall, Trichos hair restoration surgeons give hair
              loss patients experience of a lifetime. Book a consultation today!
            </p>
            <div className="mt-8 flex justify-center space-x-3">
              <Link href="/appointment">
                <BookAppointmentButton
                  bgColor="bg-violet-950"
                  textColor="text-white"
                  hoverColor="hover:bg-violet-950"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
